import { FCC } from 'types'
import useChat from '../hooks/useChat'
import ChatHeader from './ChatHeader'

const ChatLayout: FCC = ({ children }) => {
 const { updateState, state, showChatModal } = useChat()

 const handleClickBack = () => {
  updateState?.({ screen: 'chatHistory', currentGroupId: null })
 }

 return (
  <div
   className={`chat-widget ${state.minimized ? 'chat-widget-minimized' : ''}`}
  >
   <ChatHeader
    onBack={handleClickBack}
    onClose={() => {
     showChatModal?.(false)
    }}
   />
   {!state.minimized && <div className="chat-body">{children}</div>}
  </div>
 )
}

export default ChatLayout
